
import DraggableButton from './components/draggableBtn.vue' 
import Vue from 'vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)
export default {
name: 'App',
components: {
Confirm,
DraggableButton 
},
data () {
return {
logOutVisity: false
}
},
methods: {
onClick () {
this.logOutVisity = true
},
closePopup () {
this.logOutVisity = false
},
logOut () {
this.$vux.confirm.show({
title: '解绑账号',
content: '该微信已绑定到梦空间管理系统账号，确定解除绑定?',
cancelText: '取消',
confirmText: '解绑',
with: '90%',
onConfirm: () => {
this.$http({
method: 'post',
url: '/unbind'
}).then(res => {
if (+res.code === 100) {
this.setCookie('dmkj_weixin_token', '')
this.logOutVisity = false
this.$router.push({ path: '/bindLogin' })
} else {
this.$vux.toast.show({
type: 'warn',
text: res.msg || res.data.result.msg || res.data.result
})
}
}).catch(error => {
console.log(error)
})
}
})


























}
}
}



// WEBPACK FOOTER //
// ./src/App.vue